namespace Matrix.Workflow {
    export interface QueueForm {
        QueueCode: Serenity.StringEditor;
        QueueName: Serenity.StringEditor;
        QueueTypeCode: Serenity.LookupEditor;
        WorkflowCode: FormatLookupEditor;
        StatusCodes: FormatLookupEditor;
        FieldList: QueueFieldListEditor;
        ViewPermission: Serenity.StringEditor;
        ApprovePermission: Serenity.StringEditor;
        RejectPermission: Serenity.StringEditor;
        SkipPermission: Serenity.StringEditor;
        WorkflowClass1: Serenity.LookupEditor;
        WorkflowClass2: Serenity.LookupEditor;
        WorkflowClass3: Serenity.LookupEditor;
        WorkflowClass4: Serenity.LookupEditor;
        WorkflowClass5: Serenity.LookupEditor;
        InstanceKey1: Serenity.StringEditor;
        InstanceKey2: Serenity.StringEditor;
        InstanceKey3: Serenity.StringEditor;
        InstanceKey4: Serenity.StringEditor;
        InstanceKey5: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class QueueForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.Queue';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QueueForm.init)  {
                QueueForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = FormatLookupEditor;
                var w3 = QueueFieldListEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(QueueForm, [
                    'QueueCode', w0,
                    'QueueName', w0,
                    'QueueTypeCode', w1,
                    'WorkflowCode', w2,
                    'StatusCodes', w2,
                    'FieldList', w3,
                    'ViewPermission', w0,
                    'ApprovePermission', w0,
                    'RejectPermission', w0,
                    'SkipPermission', w0,
                    'WorkflowClass1', w1,
                    'WorkflowClass2', w1,
                    'WorkflowClass3', w1,
                    'WorkflowClass4', w1,
                    'WorkflowClass5', w1,
                    'InstanceKey1', w0,
                    'InstanceKey2', w0,
                    'InstanceKey3', w0,
                    'InstanceKey4', w0,
                    'InstanceKey5', w0,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
